import account from './account'
import setting from './setting'
import organization from './organization'
import calculatecode from './calculatecode'
import course from "./course"
import operate from "./operate"
import file from "./file"
import content from "./content"

export default {account, setting, organization, calculatecode, course, operate, file, content}
